import { ActionType, createReducer } from 'typesafe-actions';
import { CustomGroupListState, CUSTOM_GROUPS_FETCH_STATE } from './type.d';
import * as actions from './customGroupList.action';
import * as types from './customGroupList.actionTypes';

export type CustomGroupListAction = ActionType<typeof actions>;

export const customGroupListInitialState: CustomGroupListState = {
	page: 1,
	limit: 15,
	search: '',
	totalCustomGroups: 0,
	customGroupList: [],
	fetchState: CUSTOM_GROUPS_FETCH_STATE.SUCCESS,
	sortBy: 'customGroupName',
	sortDirection: 'asc',
	isLoading: false,
	isSuccess: false,
	error: null,
};

const getCustomGroupListReducer = createReducer<CustomGroupListState, CustomGroupListAction>(
	customGroupListInitialState,
)
	.handleAction(actions.getCustomGroupList.request, (state) => ({
		...state,
		fetchState: CUSTOM_GROUPS_FETCH_STATE.LOADING,
		error: null,
		isLoading: true,
		isSuccess: false,
	}))
	.handleAction(actions.getCustomGroupList.success, (state, action) => ({
		...state,
		customGroupList: action.payload.docs,
		fetchState: CUSTOM_GROUPS_FETCH_STATE.SUCCESS,
		isLoading: false,
		totalCustomGroups: action.payload.totalDocs ?? 0,
		isSuccess: true,
	}))
	.handleAction(actions.getCustomGroupList.failure, (state, action) => ({
		...state,
		error: action.payload.error,
		fetchState: CUSTOM_GROUPS_FETCH_STATE.ERROR,
		isLoading: false,
		isSuccess: false,
	}))
	.handleAction(types.SET_CUSTOM_GROUP_LIST_PAGE_INDEX as any, (state, action) => ({
		...state,
		page: action.payload.page,
		fetchState: CUSTOM_GROUPS_FETCH_STATE.LOADING,
		isLoading: true,
	}))
	.handleAction(types.SET_CUSTOM_GROUP_LIST_SEARCH_QUERY as any, (state, action) => ({
		...state,
		search: action.payload.search,
		page: 1, // Reset to first page on search
		fetchState: CUSTOM_GROUPS_FETCH_STATE.LOADING,
		isLoading: true,
	}))
	.handleAction(types.SET_CUSTOM_GROUP_LIST_SORT as any, (state, action) => ({
		...state,
		sortBy: action.payload.sortBy,
		sortDirection: action.payload.sortDirection,
		fetchState: CUSTOM_GROUPS_FETCH_STATE.LOADING,
		isLoading: true,
	}))
	.handleAction(types.SET_CUSTOM_GROUP_SUCCESS as any, (state, action) => ({
		...state,
		isSuccess: action.payload.value,
	}))
	.handleAction(types.RESET_CUSTOM_GROUP_LIST_FILTER as any, () => ({
		...customGroupListInitialState,
	}));

export { getCustomGroupListReducer };
